import { useParams } from 'react-router-dom';
import { Banner, Flex, Spinner } from '@optiaxiom/react';

import { useNamespacedNavigate } from '@frontend/hooks';
import { AgentExecutionItem } from '@frontend/types';

import { useGetWorkflowAgentExecution } from '../../hooks';

import { WorkflowExecutionContent } from './WorkflowExecutionContent';

export function WorkflowExecutionPage() {
  const { executionId } = useParams();
  const navigate = useNamespacedNavigate();
  const { data: execution, isFetching } = useGetWorkflowAgentExecution(executionId || '');

  if (isFetching) {
    return (
      <Flex h="full" justifyContent="center" alignItems="center">
        <Spinner size="xl" />
      </Flex>
    );
  }

  if (!execution) {
    return (
      <Flex h="full" justifyContent="center" alignItems="center">
        <Banner intent="warning">No execution found.</Banner>
      </Flex>
    );
  }

  const convertedExecution = {
    ...execution,
    status: execution.status as AgentExecutionItem['status'],
    end_time: execution.end_time || undefined,
    error_message: execution.error_message || undefined,
  };

  const handleClose = () => {
    navigate('/chat');
  };

  return <WorkflowExecutionContent execution={convertedExecution} onClose={handleClose} />;
}
